import { Component, Input, ViewEncapsulation } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { CheckpointSelectRoleToNotifyDialogComponent } from '../checkpoint-select-role-to-notify-dialog/checkpoint-select-role-to-notify-dialog.component';
import { ChecklistModel } from '../../checklist.model';
import { FiDialogsService } from '@fi-shared/fi-dialogs';
import { AppTextService } from '@fi-shared/app-text';
import { FiCustomerDataService } from '@fi-shared/fi-shared-services/fi-customer-data.service';

@Component({
    selector: 'fi-checklist-edit-checkpoint-menu',
    templateUrl: './checkpoint-menu.component.html',
    styleUrls: ['./checkpoint-menu.component.scss'],
    encapsulation: ViewEncapsulation.None,
    host: { class: 'fi-checklist-edit-checkpoint-menu' },
    standalone: false,
})
export class ChecklistEditCheckpointMenuComponent {
    @Input() checklist: ChecklistModel;
    @Input() checkpoint;
    @Input() rolesToNotify: Array<any>;

    constructor(
        private matDialog: MatDialog,
        private fiDialogsService: FiDialogsService,
        private appTextService: AppTextService,
        private customerDataService: FiCustomerDataService,
    ) {}

    checkpointNotificationOnDeviationClick($event) {
        $event.stopPropagation();
        if (this.checkpoint.$$notifyRoleChecked) {
            this.checkpoint.$$notifyRoleChecked = false;
            this.checkpoint.NotificationRoleId = null;
        } else {
            this.fiDialogsService
                .custom({
                    headerText: this.appTextService.get('checklist.notify_on_deviation_option'),
                    contentComponentRef: CheckpointSelectRoleToNotifyDialogComponent,
                    contentComponentData: {
                        rolesToNotify: this.rolesToNotify,
                    },
                })
                .onYesButtonClick((result) => {
                    this.checkpoint.$$notifyRoleChecked = true;
                    this.checkpoint.NotificationRoleId = result;
                });
        }
    }

    toggleAttachmentMandatoryOk($event) {
        $event.stopPropagation();
        this.checkpoint.IsAttachmentMandatoryOk = !this.checkpoint.IsAttachmentMandatoryOk;
    }

    toggleAttachmentMandatoryNotOk($event) {
        $event.stopPropagation();
        this.checkpoint.IsAttachmentMandatoryNotOk = !this.checkpoint.IsAttachmentMandatoryNotOk;
    }

    toggleCommentMandatoryOk($event) {
        $event.stopPropagation();
        this.checkpoint.IsCommentMandatoryOk = !this.checkpoint.IsCommentMandatoryOk;
    }

    toggleCommentMandatoryNotOk($event) {
        $event.stopPropagation();
        this.checkpoint.IsCommentMandatoryNotOk = !this.checkpoint.IsCommentMandatoryNotOk;
    }

    toggleCheckPresence($event) {
        $event.stopPropagation();
        this.checkpoint.CheckPresence = !this.checkpoint.CheckPresence;
    }

    isCheckPresenceEnabled() {
        return this.customerDataService.customerData.ChecklistPresenceEnabled;
    }

    getCheckPresenceTitleTextId() {
        return this.checklist.CheckPresenceEnabled
            ? 'checklist_qr.checkpoint_presence_required_option'
            : 'checklist_qr.checkpoint_presence_disabled';
    }
}
